import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface ICopyToolButtonProps extends IconButtonProps {
    tooltip?: string;
}

export const CopyToolButton = (props: ICopyToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.Copy}
        icon={<ContentCopyIcon />}
    />
);
